class CommunicationsApi {
    static async uploadFile(id, info) {
        try {
            const { name, type, size, link } = info;
            const code = await CommunicationsApi.createFile(id, name, type, size);
            const response = await fetch(
                `${process.env.REACT_APP_API_COMMUNICATIONS}/${id}/adjunto/${code}/datos`,
                {
                    method: 'PUT',
                    body: link,
                    headers: {
                        Authorization: sessionStorage.token,
                        Accept: 'application/json',
                        'Content-Type': type,
                    },
                },
            );
            const json = response.json();
            if (json.result !== 'success') {
                console.error(json.messages);
                const error = { type: json.result, message: json.messages.join(' ') };
                throw error;
            } else {
                return `${code}`;
            }
        } catch (error) {
            throw error;
        }
    }

    static async createFile(id, name, type, size) {
        try {
            const body = {
                nombre: name,
                tipo: type,
                tamano: size,
            };

            const response = await fetch(
                `${process.env.REACT_APP_API_COMMUNICATIONS}/${id}/adjunto`,
                {
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: {
                        Authorization: sessionStorage.token,
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                },
            )
                .then((response) => {
                    return response.json();
                })
                .then((info) => {
                    if (info.result !== 'success') {
                        console.error(info.messages);
                        const error = { type: info.result, message: info.messages.join('<br/>') };
                        throw error;
                    }
                    return info.data;
                })
                .catch((err) => {
                    throw err;
                });
            return response;
        } catch (error) {
            throw error;
        }
    }
}

export default CommunicationsApi;



// WEBPACK FOOTER //
// ./src/api/CommunicationsApi.js